import { Suspense } from "react";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

// App components
import AppRoutes from "./routes";
import { LoadingSpinner } from "./components/ui";
import { store, persistor } from "./redux/store";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import useSessionTimeout from "./hooks/useSessionTimeout";
import CookieConsent from "./components/common/CookieConsent";
import { ScrollToTop } from "./components/common/ScrollToTop";

const AppContent = () => {
  // Set session timeout to 60 minutes
  useSessionTimeout({
    timeout: 60 * 60 * 1000,
    onTimeout: () => {
      // You can add any additional cleanup or notification here
      console.log("Session timed out");
    },
  });

  return (
    <Suspense fallback={<LoadingSpinner size="xxl" />}>
      <AppRoutes />
      <ScrollToTop />
      <Toaster />
      <CookieConsent />
    </Suspense>
  );
};

const App = () => {
  return (
    <PersistGate loading={null} persistor={persistor}>
      <Provider store={store}>
        <Router>
          <AuthProvider>
            <ThemeProvider>
              <LanguageProvider>
                <AppContent />
              </LanguageProvider>
            </ThemeProvider>
          </AuthProvider>
        </Router>
      </Provider>
    </PersistGate>
  );
};

export default App;
